import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, ViewRef} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {FileUploader, FileUploaderOptions,FileUploadModule} from "ng2-file-upload";
import {StateService} from "../../services/StateService";
import {SwitchBoard} from "../../services/SwitchBoard";
import {DomSanitizer} from "@angular/platform-browser";
import {Router} from "@angular/router";
import {LoadingService} from "../../services/LoadingService";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../tpiq-services/manage-tax-strategies.service";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";
import {PageTitleService} from "../../services/PageTitle";
import {ClickOutsideDirective} from "../../directives/click.outside";
import {MatExpansionModule} from "@angular/material/expansion";
import { environment } from '../../../environments/environment';

declare var _: any;
declare let jQuery: any;

@Component({
  selector: 'app-taxlab',
  standalone: true,
  imports: [CommonModule, FormsModule, ClickOutsideDirective, MatExpansionModule, FileUploadModule],
  templateUrl: './taxlab.component.html',
  styleUrl: './taxlab.component.scss'
})
export class TaxlabComponent implements OnInit, OnDestroy {
  org: string;
  userId: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  routeSub: any;
  reveal: any = {
    uploadDisclaimer: false,
    taxlabNotes: false
  };
  uploader: FileUploader;
  taxlabFiles: Array<any> = [];

  columns: Array<any> = [
    {name: 'documentName', title: 'Document Name', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'uploadedDate', title: 'Date Uploaded', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
    {name: 'status', title: 'Status', type: 'normal', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
    {name: 'notes', title: 'Description', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true}
  ];
  uploadedDocsSort: any = {};
  sortColumnName: any;
  sortColumnOrder: any;

  /* Fields related to badge input popup */
  displayWidget: boolean;
  displayDropdown = false;
  selectedRow: any = {};
  selectedCol: any = {};
  searchEntries: Array<any> = [];
  dropSearchString: string;
  widgetLoader: boolean;
  statusTypes: Array<any> = [{name: 'Uploaded'}, {name: 'Submitted'}, {name: 'To be reviewed'}, {name: 'Incomplete'}, {name: 'Reviewed'}, {name: 'Selected to present'}];

  editorOptions = {
    heightMin: 100,
    heightMax: 120,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilySelection: true,
    placeholderText: 'Enter description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  notesOfTaxlab = '';
  currentSelectedStatus= '';
  // The Content-Security-Policy blocks inline onclick handlers, so open the
  // Zoom registration page from the component instead.
  registrationUrl = 'https://us06web.zoom.us/meeting/register/JagnOopXSKmr_rq3Ls2gLQ#/registration';

  constructor(private titleService: PageTitleService, private stateService: StateService, private _router: Router,
    private loadingService: LoadingService, private switchBoard: SwitchBoard, private toastService: ToastService,
    private manageTaxStrategiesServices: ManageTaxStrategiesServices,
    private taxPlanningService: TaxPlanningService, private dss: DomSanitizer, private changeDetectorRef: ChangeDetectorRef) {
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.setFileUploader();
  }

  ngOnInit() {
    this._init();
  }

  _init() {
    if (this.org && (this.org === 'stag-taxplaniq' || this.org === 'trialtaxplaniq')) {
      this.columns = [
        {name: 'documentName', title: 'Document Name', type: 'html', classes: 'strategy-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
        {name: 'orgName', title: 'Firm Name', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
        {name: 'uploadedDate', title: 'Date Uploaded', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true},
        {name: 'status', title: 'Status', type: 'badge-input-search', 'status-col': true, displayName: 'name', classes: 'client-column pointer zero-overflow tracker-desc table-header-badge-tooltip', sortable: true},
        {name: 'notes', title: 'Description', type: 'normal', classes: 'type-column pointer zero-overflow table-header-badge-tooltip', sortable: true}
      ];
    }
    this.getTaxlabFiles();
    this.titleService.setPageTitle('Tax Lab');
    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
    });
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  startUpload($event) {
    const base = this;
    this.loadingService.triggerLoadingEvent(true);
    setTimeout(() => {
      base.uploader.uploadAll();
    }, 1000);
  }

  setFileUploader() {
    const base = this;
    const docUrl = this.manageTaxStrategiesServices.getVideoDocumentServiceUrl(this.org, this.userId);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceID = this.org;
      payload.sourceType = 'taxlab';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.uploader.progress = 100;
        this.getTaxlabFiles();
      } else {
        this.resetUploader();
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload document');
      }
    };
  }

  resetUploader(type?) {
    this.uploader.queue.forEach((item) => {
      item.remove();
    });
  }

  getTaxlabFiles() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getTaxlabFiles(Session.getOrg(), Session.getUser().id).subscribe(files => {
      this.loadingService.triggerLoadingEvent(false);
      this.taxlabFiles = files || [];
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  downloadDocument(taxlab, type?){
    this.loadingService.triggerLoadingEvent(true);
    this.manageTaxStrategiesServices.downloadDocument(this.userId, this.org, taxlab.documentId)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        if (type && type === 'preview') {
          window.open(response.viewDocContentURL, '_blank');
        } else {
          window.open(response.temporaryURL, '_blank');
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, "Failed to download/preview tax lab document");
      });
  }

  deleteTaxlab(taxlab){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.removeTaxlab(this.userId, this.org, taxlab.id)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        _.remove(this.taxlabFiles, {id: taxlab.id});
        this.toastService.pop(TOAST_TYPE.success, 'Tax lab deleted successfully');
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try {
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to delete tax lab');
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, 'Failed to delete tax lab');
        }
      });
  }

  getTaxlabHelpOnFile(taxlab) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.postTaxlabFileHelp(Session.getOrg(), Session.getUser().id, taxlab).subscribe(files => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.success, 'Tax lab request sent successfully');
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      try {
        this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to send tax lab request');
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, 'Failed to send tax lab request');
      }
    });
  }

  hideReveal(key){
    this.currentSelectedStatus = '';
    this.notesOfTaxlab = '';
    this.reveal[key] = false;
  }

  showDisclaimer() {
    this.reveal.uploadDisclaimer = true;
  }

  openRegistration() {
    window.open(this.registrationUrl, '_blank', 'noopener');
  }

  columnSort(column, columns) {
    if (column.sortable) {
      let order = this.getSortType(column);
      this.uploadedDocsSort[column.name] = order;
      this.sortColumnName = column.name;
      this.sortColumnOrder = order;
      this.resetSortOrder(column, columns);
    }
  }

  resetSortOrder(column, columns) {
    _.each(columns, function(col){
      if (col.name !== column.name) {
        col.sortType = '';
      }
    });
  }

  getSortType(column){
    if (!column.sortType){
      column.sortType = 'asc';
    } else if (column.sortType == 'asc'){
      column.sortType = 'desc';
    } else if (column.sortType == 'desc'){
      column.sortType = 'asc';
    }
    return column.sortType;
  }

  onMouseClick(e: MouseEvent, row, column) {
    const base = this;
    this.dropSearchString = '';
    this.selectedRow = _.cloneDeep(row);
    this.selectedCol = _.cloneDeep(column);
    if (column.name == 'status') {
      this.searchEntries = _.cloneDeep(this.statusTypes) || [];
    }
    const popupHeight = 250, // hardcode these values
      popupWidth = 250;    // or compute them dynamically

    let popupXPosition,
      popupYPosition;

    if (e.clientX + popupWidth > window.innerWidth) {
      popupXPosition = e.pageX - popupWidth;
    } else {
      popupXPosition = e.pageX;
    }

    if (e.clientY + popupHeight > window.innerHeight) {
      popupYPosition = e.pageY - popupHeight;
    } else {
      popupYPosition = e.pageY;
    }

    if (base.selectedCol.view && base.selectedCol.view === 'inReveal') {
      popupYPosition = popupYPosition - 55;
      popupXPosition = popupXPosition - 140;
    }
    this.selectedCol.editable = this.selectedCol.editable === undefined ? true : this.selectedCol.editable;
    this.displayDropdown = true;
    this.displayWidget = false;
    setTimeout(() => {
      this.displayWidget = true;
      this.detectChanges();
    }, 10);
    setTimeout(() => {
      jQuery('#widget-container').css({
        top: popupYPosition,
        left: popupXPosition,
        position: 'absolute',
        padding: '5px'
      });
    }, 20);
  }

  detectChanges(): void {
    if (!(this.changeDetectorRef as ViewRef).destroyed) {
      this.changeDetectorRef.detectChanges();
    }
  }

  closeContainer() {
    this.displayWidget = false;
    this.dropSearchString = '';
    if (!this.reveal.taxlabNotes) {
      this.selectedRow = {};
      this.selectedCol = {};
    }
    this.detectChanges();
  }

  filterEntries($event) {
    const base = this;
    const searchString = $event.target.value || '';
    if (searchString) {
      this.searchEntries = _.filter(this.statusTypes, function(obj) {
        return obj.name.toLowerCase().indexOf(searchString.toLowerCase()) != -1;
      });
    } else {
      this.searchEntries = _.cloneDeep(this.statusTypes);
    }
  }

  triggerOnSelect($event, entry) {
    const data: any = _.find(this.taxlabFiles, {id: this.selectedRow.id});
    this.notesOfTaxlab = data.notes || '';
    this.currentSelectedStatus = entry.name;
    this.reveal.taxlabNotes = true;
  }

  resetSearchEntries() {
    const base = this;
    setTimeout(() => {
      base.searchEntries = [];
      base.displayDropdown = false;
      base.displayWidget = false;
      base.detectChanges();
    }, 200);
  }

  updateTaxlab(taxlab) {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateTaxlab(Session.getOrg(), Session.getUser().id, taxlab).subscribe(files => {
      this.loadingService.triggerLoadingEvent(false);
      this.hideReveal('taxlabNotes');
      this.toastService.pop(TOAST_TYPE.success, 'Tax lab updated successfully');
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      try {
        this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to update tax lab');
      } catch (e) {
        this.toastService.pop(TOAST_TYPE.error, 'Failed to update tax lab');
      }
    });
  }

  updateNotesOfTaxlab() {
    const data: any = _.find(this.taxlabFiles, {id: this.selectedRow.id});
    this.resetSearchEntries();
    if (this.selectedCol.name == 'status') {
      data['status'] = this.currentSelectedStatus;
    }
    data['notes'] = this.notesOfTaxlab;
    this.updateTaxlab(data);
  }

}
